import { Heading, Icon } from 'copilot-design-system';

export const AssistantError = ({ errorMessage }: { errorMessage: string }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-1 py-6">
      <Icon icon="Warning" className="h-5 w-5 text-warning-primary" />
      <Heading>{errorMessage}</Heading>
    </div>
  );
};
